/**
 * Always use conditional dynamic imports for big libraries such as tiny-slider.
 * When choosing libraries, please consider their use of dependencies. Use vanilla JS libraries whenever possible.
 */

import jQuery from 'jquery';
import 'slick-carousel';

export const initSlider = () => {
	jQuery(() => {
		const $blocks = jQuery('.js-blocks-slider');
		$blocks.slick({
			rows: 0,
			arrows: false,
			infinite: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			variableWidth: true,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		});

		const $holder = jQuery('.js-slider');
		$holder.slick({
			rows: 0,
			dots: true,
			infinite: false,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						arrows: false,
					},
				},
			],
		});

		$holder.on('afterChange', (event, slick, currentSlide) => {
			const vid = jQuery(`.slider__slide[data-slick-index="${currentSlide}"] video`);
			if (vid.length) {
				vid[0].play();
			} else {
				jQuery('.slider__slide video').each(function () {
					jQuery(this).get(0).pause();
				});
			}
		});
	});
};
